import { TranslationObject } from '../../i18n/translation';

const namespace = 'practiceactivity/vurdering';

const translations: TranslationObject = {
  useVurderingInfoText: {
    id: `${namespace}.useVurderingInfoText`,
    nb: 'Skal Arbeidslivportalen benyttes til vurdering av studentene i denne aktiviteten?',
    en: 'Should Arbeidslivportalen be used for the assessment of the students in this activity?',
  },
  yes: {
    id: `${namespace}.useVurdering`,
    nb: 'Ja',
    en: 'Yes',
  },
  no: {
    id: `${namespace}.dontUseVurdering`,
    nb: 'Nei',
    en: 'No',
  },
  vurderingsinstillingerTitle: {
    id: `${namespace}.vurderingsinstillingerTitle`,
    nb: 'Vurderingsinnstillinger',
    en: 'Assessment settings',
  },
  vurderingskriterierTitle: {
    id: `${namespace}.vurderingskriterierTitle`,
    nb: 'Vurderingskriterier',
    en: 'Assessment criteria',
  },
  vurderingsinnstillingerSubtitle: {
    id: `${namespace}.vurderingsinnstillingerSaveMidtveisError`,
    nb: 'Midtveisvurdering kan kun velges dersom sluttvurdering også er valgt.',
    en: 'Midtveisvurdering can only be chosen if sluttvurdering is also chosen',
  },
};

export default translations;
